





































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import {
  synthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import AvgScore from '../../_components/AvgScore.vue'
import Radar from '../../_components/charts/Radar.vue'
import BarDifference from '../../_components/charts/BarDifference.vue'
import Child from './child.vue'

@Component({
  components: {
    Child,
    BasePanel,
    AvgScore,
    Radar,
    BarDifference
  }
})
export default class extends Vue {
  @Prop({}) private data!: any;
  private pieData: any = {
    others: [],
    details: []
  };
  private searchParams: any = {};
  private barDataArray: Array<object> = [];
  private colorList: any = [];
  // 当前能区
  private energyZoneType: any = '';
  private visibleJR: any = false;

  private classroomName: any = '';
  private sexName: any = '';
  private ageName: any = '';

  created() {
    if (!this.$route.query.searchParams) return
    this.searchParams = JSON.parse(this.$route.query.searchParams as string)

    const params = this.searchParams
    localStorage.setItem('searchParams', JSON.stringify(params))

    const classroomNames: any = []
    const sexNames: any = []
    const ageNames: any = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    this.$enums.groupAnalysisAgeType.map((v: any) => {
      if (params.ageRangeTypes.indexOf(v.code) !== -1) {
        ageNames.push(v.description)
      }
    })
    this.ageName = ageNames.join('、')
    synthEZAvgScore(this.searchParams).then((res) => {
      this.pieData = res.data.synthEZAvgScore
      this.barDataArray = res.data.barChart || []
    })
    // let obj: any = this.data.pie
    // obj.HeightLastTypeIntro = obj.title
    // obj.data = []
    // this.data.pie.dataList.map(v => {
    //   obj.data.push({ name: v.name, value: v.value * 100 })
    // })
    // this.list.push(obj)
    // this.data.staminaHeightPercentVoLine.map(v => {
    //   this.list.push(v)
    // })
  }

  private openClild(code: any) {
    console.log(code)
    this.energyZoneType = code
    this.visibleJR = true
  }
}
